<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" :lg="6" class="d-flex ga-2 align-center justify-start">
      <div class="d-flex align-center ga-2">
        <Input
          v-model="search"
          type="search"
          :icon="SearchIcon"
          placeholder="Search here..."
          @keyup="handleDebouncedInput"
        />
        <!-- <button @click="handleInput" class="cancel-btn" style="width: auto">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.9881 4.52007C11.673 4.14956 8.32686 4.14956 5.01172 4.52007C4.78742 4.54514 4.6794 4.80819 4.82135 4.98366L7.7522 8.60662C8.80211 9.90447 9.37491 11.5233 9.37491 13.1926V15.6003L10.6249 16.517V13.1926C10.6249 11.5233 11.1977 9.90446 12.2476 8.60662L15.1785 4.98366C15.3204 4.80819 15.2124 4.54514 14.9881 4.52007ZM4.87288 3.27781C8.2803 2.89698 11.7195 2.89698 15.1269 3.27781C16.3327 3.41257 16.9134 4.82656 16.1503 5.76983L13.2194 9.39279C12.3495 10.4681 11.8749 11.8094 11.8749 13.1926V17.7503C11.8749 17.9859 11.7425 18.2014 11.5324 18.3079C11.3223 18.4143 11.0702 18.3936 10.8803 18.2543L8.38031 16.421C8.21976 16.3033 8.12491 16.1161 8.12491 15.917V13.1926C8.12491 11.8094 7.65031 10.4682 6.78038 9.39279L3.84953 5.76983C3.08646 4.82656 3.66711 3.41257 4.87288 3.27781Z"
              fill="#666666"
            />
          </svg>
        </button> -->
      </div>
      <v-menu transition="scale-transition">
        <template v-slot:activator="{ props }">
          <span v-bind="props" class="dropdown-button">
            <span>{{ platform ? platform.title : "Platform" }}</span>
            <svg
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 3L5 7L9 3"
                stroke="#666666"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </template>

        <v-list>
          <v-list-item v-for="(item, i) in platformsItems" :key="i">
            <v-list-item-title @click="selectPlatform(item)">{{
              item.title
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <div class="custom-calender">
        <v-date-input
          prepend-icon=""
          prepend-inner-icon="$calendar"
          variant="solo"
          label="Start Date"
          hide-details
          v-model="start_date"
        ></v-date-input>
      </div>
      <div class="custom-calender">
        <v-date-input
          prepend-icon=""
          prepend-inner-icon="$calendar"
          variant="solo"
          label="End Date"
          hide-details
          v-model="end_date"
        ></v-date-input>
      </div>
    </v-col>
    <v-col cols="12" :lg="6" class="d-flex ga-2 align-center justify-end">
      <div class="d-flex">
        <v-btn @click="drawer = !drawer" variant="text" class="engagement-btn">
          <div class="d-flex align-center ga-2">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.51582 0C3.5051 0.00011115 2.67122 0.834196 2.67122 1.84532V2.66706H1.8446C0.833841 2.66706 -2.66602e-07 3.50123 0 4.51238V12.1567C0 13.1679 0.833814 14.0021 1.8446 14.0021H2.66602V15.3369C2.66984 15.8821 3.28999 16.1923 3.72826 15.8682L6.21853 14.0021H9.33756C10.2265 14.0021 10.2265 12.6685 9.33756 12.6685H5.99723C5.85355 12.6687 5.71394 12.7153 5.59889 12.8014L3.99902 13.9969V13.3327C3.99772 12.9643 3.69813 12.6671 3.32992 12.6685H1.8446C1.55428 12.6686 1.33301 12.4472 1.33301 12.1567V4.51238C1.33301 4.22192 1.55425 4.00059 1.8446 4.00059H2.67122V9.48837C2.67122 10.4995 3.50506 11.335 4.51582 11.335H9.78016L12.2704 13.1999C12.3693 13.2728 12.4865 13.317 12.6089 13.3276C12.7313 13.3382 12.8543 13.3146 12.9642 13.2597C13.0741 13.2047 13.1667 13.1204 13.2318 13.0161C13.2968 12.9117 13.3317 12.7915 13.3327 12.6685V11.335H14.1541C15.1649 11.3351 16 10.4995 16 9.48837V1.84532C16 0.834167 15.1649 -2.66706e-07 14.1541 0H4.51582ZM4.51582 1.33353H14.1541C14.4444 1.33353 14.6657 1.55486 14.6657 1.84532V9.48837C14.6657 9.77884 14.4444 10.0015 14.1541 10.0015H12.6688C12.492 10.0008 12.3222 10.0704 12.1967 10.1949C12.0713 10.3195 12.0004 10.4888 11.9997 10.6656V11.3298L10.3998 10.1343C10.2848 10.0483 10.1451 10.0017 10.0015 10.0015H4.51582C4.22548 10.0015 4.00423 9.77884 4.00423 9.48837V1.84532C4.00423 1.55497 4.22543 1.33356 4.51582 1.33353ZM7.45001 2.69441C7.22531 2.6951 6.99538 2.7362 6.77439 2.82984C6.33241 3.01714 5.96437 3.3855 5.66789 3.88729C5.33433 4.45183 5.26484 5.09883 5.39191 5.67922C5.51898 6.25961 5.82014 6.78359 6.19901 7.25497C6.57788 7.72636 7.03938 8.14627 7.54243 8.49474C7.79396 8.66897 8.05794 8.8214 8.32349 8.95705C8.58904 9.09269 8.85988 9.21269 9.13058 9.30215C9.26507 9.34612 9.41006 9.34612 9.54454 9.30215C9.81525 9.21269 10.0861 9.09269 10.3516 8.95705C10.6172 8.8214 10.8773 8.66897 11.1288 8.49474C11.6318 8.14627 12.0972 7.72636 12.4761 7.25497C12.855 6.78359 13.1561 6.25961 13.2832 5.67922C13.4103 5.09883 13.3421 4.45183 13.0085 3.88729C12.7121 3.3855 12.3427 3.01714 11.9007 2.82984C11.4588 2.64255 10.9797 2.66611 10.5821 2.79989C10.1845 2.93367 9.84484 3.16278 9.54975 3.42498C9.47289 3.49328 9.40866 3.56864 9.33756 3.64116C9.26611 3.56823 9.19876 3.49365 9.12147 3.42498C8.82639 3.16278 8.49068 2.93367 8.09308 2.79989C7.89428 2.733 7.6747 2.69371 7.45001 2.69441ZM7.46563 4.02142C7.52441 4.02077 7.58918 4.0333 7.67 4.06049C7.83164 4.11488 8.03914 4.24129 8.24018 4.41992C8.34069 4.50923 8.43671 4.61242 8.53047 4.71944C8.62423 4.82647 8.71279 4.93664 8.79212 5.04892C8.85355 5.1368 8.93527 5.20856 9.03034 5.25811C9.12541 5.30765 9.23102 5.33353 9.33821 5.33353C9.44541 5.33353 9.55102 5.30765 9.64609 5.25811C9.74116 5.20856 9.82288 5.1368 9.88431 5.04892C9.96365 4.93663 10.0509 4.82647 10.1447 4.71944C10.2384 4.61242 10.3344 4.50923 10.435 4.41992C10.636 4.24129 10.8435 4.11488 11.0051 4.06049C11.1668 4.00611 11.2641 4.01137 11.38 4.06049C11.496 4.10962 11.666 4.23075 11.8617 4.56187C12.0203 4.83024 12.0484 5.08228 11.9801 5.39402C11.9119 5.70576 11.7226 6.06947 11.4386 6.42282C11.1546 6.77617 10.7786 7.11467 10.3712 7.39692C10.1674 7.53805 9.95671 7.66321 9.74632 7.77067C9.60674 7.84197 9.47337 7.89049 9.33756 7.94388C9.20176 7.89049 9.06839 7.84197 8.92881 7.77067C8.71842 7.66321 8.5077 7.53805 8.30396 7.39692C7.89649 7.11467 7.52052 6.77617 7.23651 6.42282C6.95251 6.06947 6.76323 5.70576 6.69498 5.39402C6.62673 5.08228 6.65487 4.83024 6.81344 4.56187C7.00909 4.23075 7.18047 4.10962 7.2964 4.06049C7.35436 4.03593 7.40684 4.02208 7.46563 4.02142Z"
                fill="white"
              />
            </svg>

            <span class="btn-text"> Engagements </span>
          </div>
        </v-btn>
      </div>
      <div>
        <v-btn class="reset-filter" variant="text" @click="resetAllData">
          <span class="btn-text" style="color: #666666"> Reset Filter </span>
        </v-btn>

        <v-btn class="reset-filter" variant="text" @click="openDialog">
          <span class="btn-text" style="color: #666666"> Change Page </span>
        </v-btn>

      </div>
      <div class="">
        <v-btn variant="text">
          <div class="d-flex align-center ga-2">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10M4.66667 6.66667L8 10M8 10L11.3333 6.66667M8 10V2"
                stroke="#666666"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span
              class="btn-text"
              @click="exportToExcel"
              style="color: #666666"
            >
              Export Report
            </span>
          </div>
        </v-btn>
      </div>
    </v-col>
  </v-row>
  <Engagements :drawer="drawer" @update:drawer="drawer = $event" />
</template>
<script>
import SearchIcon from "@/assets/images/icons/search.svg";
import Engagements from "@/components/EngagementInsights/Engagements.vue";
import Input from "@/components/crm/assets/Input.vue";
import { VDateInput } from "vuetify/labs/VDateInput";
import { EngagementAndInsightsStore } from "@/store/EngagementAndInsights/EngagementAndInsights";
import * as XLSX from "xlsx";

export default {
  name: "EngagementAndInsightsFilter",
  components: { Input, VDateInput, Engagements },
  data() {
    return {
      search: "",
      SearchIcon,
      platformsItems: [
        { id: 1, title: "Facebook" },
        // { id: 2, title: "Twitter" },
        { id: 3, title: "Instagram" },
        // { id: 4, title: "Tiktok" },
        // { id: 5, title: "Snapchat" },
      ],
      start_date: null,
      end_date: null,
      platform: null,
      drawer: false,
      store: EngagementAndInsightsStore(),
      debounceTimer: null,
    };
  },
  watch: {
    start_date() {
      this.store.start_date = this.formatDateFromInput(this.start_date);
      this.store?.FilterSearch();
    },
    end_date() {
      this.store.end_date = this.formatDateFromInput(this.end_date);
      this.store?.FilterSearch();
    },
  },
  methods: {
    handleDebouncedInput() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.handleInput();
      }, 2000);
    },
    formatDateFromInput(date) {
      if (!date) return "";
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(d.getDate()).padStart(2, "0")}`;
    },
    handleInput() {
      this.store.title = this.search;
      this.store?.FilterSearch();
    },
    selectPlatform(item) {
      this.platform = item;
      this.store.filter_by = this.platform.title.toLocaleLowerCase();
      this.store?.FilterSearch();
    },
    resetAllData() {
      this.search = "";
      this.start_date = null;
      this.end_date = null;
      this.platform = null;
      this.store.title = "";
      this.store.start_date = "";
      this.store.end_date = "";
      this.store.filter_by = "";
      this.store?.FilterSearch();
    },
    exportToExcel() {
      const worksheet = XLSX.utils.json_to_sheet(this.store.body);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, `insights`);
      XLSX.writeFile(workbook, `insights.xlsx`);
    },
    openDialog(){
      this.store.dialog = true;
    }
  },
  mounted(){
    // this.resetAllData()
  }

};
</script>
<style>
.custom-calender .v-input .v-input__control .v-field {
  width: 150px;
  height: 32px;
  border-radius: 8px;
  border: 1px;
  padding: 6px 8px 6px 8px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid #e6e6e6;
  color: #666666;
  box-shadow: unset;
}
.custom-calender .v-input .v-input__control .v-field__field .v-field__input {
  padding: 0px;
}
</style>
<style scoped>
.dropdown-button {
  width: 125px;
  height: 32px;
  border-radius: 8px;
  border: 1px;
  padding: 6px 8px 6px 8px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid #e6e6e6;
  color: #666666;
}
.engagement-btn {
  height: 36px;
  padding: 9px 14px 9px 14px;
  border-radius: 8px;
  background: #237276 !important;
  color: #ffffff;
}
.btn-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 16.94px;
  text-transform: capitalize;
}
</style>
